// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"a0f7c2fa","23":"e4771177","58":"15a652b8","229":"9ba4a83c","248":"4ad7573c","643":"ed2ecc48","819":"91b73d06","858":"f3dfaade"}[chunkId] + ".chunk.css";
};